import template from './resultsDirection.html';
import controller from './ResultsDirectionController';

function resultsDirection() {
  return {
    restrict: 'E',
    scope: {
      filter: '=',
      type: '@'
    },
    template,
    controller: 'ResultsDirectionController'
  };
}

export default function (ngModule) {
  ngModule.directive('resultsDirection', [
    resultsDirection
  ]);
  controller(ngModule);
}
